var slider = new KeenSlider("#team-slider", {
  loop: true,
  breakpoints: {
    '(max-width: 749px)': {
      slides: {
        perView: 2,
      }
    },
    '(min-width: 750px)': {
      slides: {
        perView: 3,
      }
    },
    '(min-width: 990px)': {
      initial: 2,
      slides: {
        origin: 0.5,
        perView: 4.5,
      }
    }
  }
}, [navigation]);